var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCurrency = function SvgCurrency(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_732_112208)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.7435,
    cy: 34.8153,
    rx: 26.5952,
    ry: 31.4615,
    transform: "rotate(-9.11532 31.7435 34.8153)",
    fill: "url(#paint0_linear_732_112208)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.6541,
    cy: 34.1881,
    rx: 26.0293,
    ry: 31.4615,
    transform: "rotate(-9.11532 35.6541 34.1881)",
    fill: "url(#paint1_linear_732_112208)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 21.7734,
    ry: 26.3174,
    transform: "matrix(-0.987372 0.158422 0.158422 0.987372 35.6546 34.1883)",
    fill: "url(#paint2_linear_732_112208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9984 45.1177C38.5219 45.4687 37.1231 45.4634 35.8021 45.1017C34.4812 44.74 33.2917 44.02 32.2337 42.9418C31.1962 41.8587 30.3307 40.4513 29.6374 38.7197L30.268 39.3218L27.8071 39.9069C27.4995 39.98 27.2084 39.9402 26.9338 39.7875C26.6542 39.6142 26.4752 39.3625 26.3967 39.0323C26.3182 38.7022 26.3672 38.4072 26.5438 38.1472C26.7203 37.8872 26.9624 37.7207 27.27 37.6476L29.6078 37.0918L29.2862 37.7895C29.0775 37.1851 28.8972 36.5631 28.7451 35.9235C28.6086 35.2584 28.4947 34.6424 28.4033 34.0756L29.0352 34.5466L26.6666 35.1097C26.359 35.1829 26.0679 35.1431 25.7933 34.9904C25.5137 34.8171 25.3372 34.5756 25.2636 34.2661C25.1851 33.936 25.2341 33.641 25.4106 33.381C25.5823 33.1004 25.8219 32.9236 26.1295 32.8504L28.7442 32.2288L28.3056 33.1178C28.1405 31.2388 28.2799 29.5925 28.7239 28.179C29.1834 26.74 29.9216 25.5617 30.9385 24.6442C31.9553 23.7267 33.202 23.0924 34.6786 22.7414C35.7039 22.4976 36.7275 22.4286 37.7494 22.5345C38.7663 22.6197 39.7424 22.9435 40.6778 23.5059C40.9779 23.6743 41.1905 23.8854 41.3158 24.139C41.4411 24.3926 41.4946 24.6632 41.4764 24.951C41.4532 25.2181 41.3665 25.4458 41.2163 25.6341C41.066 25.8224 40.8576 25.9482 40.591 26.0116C40.3244 26.075 40.0182 26.017 39.6722 25.8377C39.0516 25.5056 38.3886 25.3145 37.6833 25.2642C36.978 25.2139 36.2665 25.274 35.5488 25.4447C34.6464 25.6592 33.8727 26.0502 33.2277 26.6178C32.5826 27.1853 32.1121 27.9402 31.8161 28.8826C31.5407 29.82 31.4373 30.9346 31.506 32.2262L30.8052 31.7388L35.4194 30.6418C35.7475 30.5638 36.0411 30.6139 36.3001 30.7921C36.5796 30.9654 36.7562 31.2068 36.8298 31.5163C36.9034 31.8258 36.8543 32.1209 36.6827 32.4015C36.5267 32.6565 36.2846 32.8231 35.9565 32.9011L31.127 34.0493L31.6098 33.3459C31.666 33.8558 31.7726 34.4408 31.9295 35.101C32.0865 35.7613 32.2644 36.373 32.4633 36.9361L31.7304 36.5871L36.5599 35.4389C36.888 35.3609 37.1816 35.411 37.4406 35.5892C37.7152 35.7419 37.8893 35.973 37.9629 36.2825C38.0365 36.592 37.9875 36.8871 37.8158 37.1676C37.6647 37.4434 37.4251 37.6202 37.097 37.6982L32.6366 38.7587L32.8894 38.0446C33.4093 39.2289 34.0056 40.188 34.6784 40.9218C35.3668 41.6301 36.1267 42.0925 36.9582 42.309C37.7897 42.5255 38.6566 42.5265 39.5589 42.312C40.2972 42.1365 40.9518 41.8827 41.5229 41.5508C42.0891 41.1982 42.6131 40.7139 43.095 40.098C43.3487 39.7979 43.5985 39.6186 43.8446 39.5601C44.1063 39.4761 44.3491 39.4946 44.5729 39.6158C44.7918 39.7164 44.9614 39.8831 45.0818 40.1161C45.2178 40.3236 45.2869 40.5687 45.2892 40.8516C45.307 41.1089 45.2199 41.3803 45.0277 41.6658C44.5071 42.5743 43.7963 43.321 42.8953 43.9058C41.9894 44.4699 41.0238 44.8739 39.9984 45.1177Z",
    fill: "#90CAF9"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.2808,
    cy: 54.0115,
    rx: 26.5952,
    ry: 31.4615,
    transform: "rotate(12.5145 63.2808 54.0115)",
    fill: "url(#paint3_linear_732_112208)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.1475,
    cy: 54.8698,
    rx: 26.0293,
    ry: 31.4615,
    transform: "rotate(12.5145 67.1475 54.8698)",
    fill: "url(#paint4_linear_732_112208)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 21.7734,
    ry: 26.3174,
    transform: "matrix(-0.976241 -0.216686 -0.216686 0.976241 67.148 54.8696)",
    fill: "url(#paint5_linear_732_112208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.828 66.196L61.1749 64.6926C58.1346 63.7102 56.4957 60.3553 57.5139 57.2037C57.7595 56.4437 58.5935 56.017 59.3536 56.2626C60.1136 56.5082 60.5403 57.3422 60.2947 58.1022C59.7736 59.7151 60.5718 61.4266 62.0734 61.9118L66.7265 63.4153C67.9315 63.8046 69.28 63.0529 69.6993 61.7552C70.2204 60.1424 69.7476 59.6415 68.9099 59.0023L62.2896 53.9559C61.0053 52.9882 59.4062 51.284 60.4784 47.9657C61.4009 45.1108 64.3868 43.5368 67.1304 44.4233L71.7835 45.9268C74.8238 46.9091 76.4628 50.2641 75.4445 53.4156C75.1989 54.1757 74.365 54.6023 73.6049 54.3567C72.8448 54.1111 72.4182 53.2772 72.6638 52.5171C73.1849 50.9043 72.3866 49.1927 70.885 48.7075L66.2319 47.2041C65.0269 46.8147 63.6785 47.5665 63.2592 48.8642C62.738 50.477 63.2109 50.9778 64.0485 51.617L70.6689 56.6634C71.9532 57.6312 73.5523 59.3353 72.4801 62.6537C71.5451 65.4841 68.5717 67.0825 65.828 66.196Z",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4356 67.8227C61.6755 67.5771 61.2489 66.7431 61.4944 65.983L68.6824 43.7371C68.928 42.977 69.7619 42.5503 70.522 42.7959C71.2821 43.0415 71.7087 43.8755 71.4631 44.6355L64.2752 66.8815C64.0296 67.6416 63.1956 68.0682 62.4356 67.8227Z",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 92,
    rx: 39,
    ry: 2,
    fill: "url(#paint6_linear_732_112208)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_732_112208",
    x1: 5.14834,
    y1: 33.1219,
    x2: 41.0338,
    y2: 10.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ECCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_732_112208",
    x1: 9.62479,
    y1: 32.4948,
    x2: 53.5252,
    y2: 40.5958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_732_112208",
    x1: -19.6882,
    y1: 18.8618,
    x2: 42.6505,
    y2: 20.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560479,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_732_112208",
    x1: 36.6856,
    y1: 52.3181,
    x2: 72.5711,
    y2: 29.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ECCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_732_112208",
    x1: 41.1182,
    y1: 53.1765,
    x2: 85.0185,
    y2: 61.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_732_112208",
    x1: -19.6882,
    y1: 18.8618,
    x2: 42.6505,
    y2: 20.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560479,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_732_112208",
    x1: 8.8,
    y1: 92.8,
    x2: 80.2613,
    y2: 90.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEFF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_732_112208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCurrency);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "currency.6109e8fa06ef309ff402b81644af53d6.svg";